import { Box, Card, CardBody, CardHeader, Heading, HStack, Icon, VStack } from "@chakra-ui/react";
import React, { useMemo } from "react"
import { Trans, useTranslation } from "react-i18next";
import moment from "moment";
import CallIcon from "../../plugin/components/common/icons/CallIcon";
import { Line } from "react-chartjs-2";
import { CategoryScale, Chart, Filler, LinearScale, LineElement, PointElement, Tooltip } from "chart.js";
import annotationPlugin from 'chartjs-plugin-annotation';

Chart.register(CategoryScale, PointElement, LinearScale, LineElement, Filler, Tooltip, annotationPlugin);

/**
 * Renders the trends card
 * 
 * @returns The trends card
 */
const TrendsCard = () => {
    const { t } = useTranslation();

    const currentMonth = moment().month();

    const labels = useMemo(() => ([
        t("common.months.january").slice(0, 1),
        t("common.months.february").slice(0, 1),
        t("common.months.march").slice(0, 1),
        t("common.months.april").slice(0, 1),
        t("common.months.may").slice(0, 1),
        t("common.months.june").slice(0, 1),
        t("common.months.july").slice(0, 1),
        t("common.months.august").slice(0, 1),
        t("common.months.september").slice(0, 1),
        t("common.months.october").slice(0, 1),
        t("common.months.november").slice(0, 1),
        t("common.months.december").slice(0, 1),
    ]), [t]);

    const values = useMemo(() => ([70, 60, 25, 25, 45, 60, 75, 90, 40, 25, 20, 80]), []);

    const data = useMemo(() => ({
        labels: labels,
        datasets: [
            {
                data: values,
                borderColor: "#1F9FFF",
                pointRadius: 0,
                backgroundColor: (context) => {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;
                    if (!chartArea) {
                        return;
                    }
                    const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top)
                    gradient.addColorStop(0, "#FFFFFF");
                    gradient.addColorStop(1, "#1F9FFF");
                    return gradient;
                },
                fill: "start"
            }
        ]
    }), [labels, values])

    return (
        <Card borderWidth={"1px"} borderColor={"#54C0E8"} width={"full"} padding={"8px"} gap={"8px"} boxShadow={"none"}>
            <CardHeader padding={0}>
                <HStack justifyContent={"flex-start"} paddingX={"5px"}>
                    <Icon as={CallIcon} color={"#1F9FFF"} />
                    <Heading fontSize={"14px"} color={"#1F9FFF"} fontWeight={400}>
                        <Trans>operator.annualTrends.title</Trans>
                    </Heading>
                </HStack>
            </CardHeader>
            <CardBody padding={0}>
                <VStack height={"full"} width={"full"}>
                    <Box height={"120px"} width={"full"}>
                        <Line data={data} options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    grid: {
                                        display: false,
                                    },
                                    border: {
                                        display: false,
                                    },
                                    ticks: {
                                        font: {
                                            size: "10px"
                                        }
                                    }
                                },
                                y: {
                                    min: 0,
                                    max: 100,
                                    grid: {
                                        display: false,
                                    },
                                    border: {
                                        display: false,
                                    },
                                    ticks: {
                                        display: false,
                                    }
                                }
                            },
                            plugins: {
                                annotation: {
                                    annotations: [
                                        {
                                            type: 'line',
                                            xMin: currentMonth,
                                            xMax: currentMonth,
                                            yMin: 0,
                                            yMax: values[currentMonth],
                                            value: labels[currentMonth],
                                            borderColor: '#1F9FFF',
                                            borderWidth: 2,
                                            borderDash: [5],
                                        },
                                        {
                                            type: "point",
                                            xValue: currentMonth,
                                            yValue: values[currentMonth],
                                            backgroundColor: "white",
                                            borderColor: "#1F9FFF",
                                            borderWidth: 5,
                                            radius: 4
                                        }
                                    ]
                                },

                            }
                        }} />
                    </Box>
                </VStack>
            </CardBody>
        </Card >
    )
}

export default React.memo(TrendsCard)